import { createSlice } from '@reduxjs/toolkit';
import { InitialStateType } from 'src/redux/job-details/types';
import reducers from 'src/redux/job-details/reducers';
import extraReducers from 'src/redux/job-details/extra-reducers';

export const defaultWebHookDetails = {
  data: [],
  meta: {
    current_page: 0,
    from: 0,
    last_page: 0,
    links: [],
    path: '',
    per_page: 0,
    to: 0,
    total: 0,
  },
};

export const lookUpInitialState: InitialStateType = {
  data: {
    work_order_id: '',
    state: {
      label: '',
      value: '',
    },
    child_job_exist: false,
    allowed_states: [],
    address: '',
    service_category: '',
    webhook_details: {
      enabled: false,
      url: '',
    },
  },
  source: {},
  webHookDetails: defaultWebHookDetails,
};

const jobDetailSlice = createSlice({
  name: 'jobDetails',
  initialState: lookUpInitialState,
  reducers,
  extraReducers,
});
export const {
  updateJobDetailsData,
  clearState,
} = jobDetailSlice.actions;
export default jobDetailSlice.reducer;
